module.exports = __webpack_public_path__ + "img/CI.0bca2eb8.svg";